var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 41V36M26 41V33.5M38.5 41V28.5M2.25 26C2.25 14.805 2.25 9.205 5.7275 5.7275C9.205 2.25 14.8025 2.25 26 2.25C37.195 2.25 42.795 2.25 46.2725 5.7275C49.75 9.205 49.75 14.8025 49.75 26C49.75 37.195 49.75 42.795 46.2725 46.2725C42.795 49.75 37.1975 49.75 26 49.75C14.805 49.75 9.205 49.75 5.7275 46.2725C2.25 42.795 2.25 37.1975 2.25 26Z",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.98 24.7152C16.3675 24.8952 28.585 24.0827 35.535 13.0527M30.98 11.7202L35.67 10.9652C36.24 10.8927 37.08 11.3452 37.2875 11.8827L38.525 15.9777",
    stroke: "#848484",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.16f56d2f5cfeaf46f2cb8076aa1e2db0.svg";
export { ForwardRef as ReactComponent };